import React, { useEffect } from 'react';
import i18n from 'i18next';
import { Container } from '../../../common/components/layout';
import useStyles from './PatrolListIframe.styles';
import useAgent from '../../../common/hooks/useAgent';
import TokenAgent from '../../../token/agents/tokenAgent';

const PatrolListIframe = () => {
  const classes = useStyles();
  const [get, token] = useAgent(TokenAgent.get);

  useEffect(() => {
    async function fetchData() {
      await get();
    }
    fetchData();
  }, [get]);

  return (
    <Container>
      <div className={classes.wrapper}>
        {token?.publicKey ? (
          <iframe
            className={classes.iframe}
            src={`${token.baseUrl}/mustang/patrols/?token=${encodeURIComponent(token.publicKey)}`}
            title={i18n.t('patrol.iframe.title')}
          />
        ) : (
          <div>{i18n.t('patrol.iframe.loading')}</div>
        )}
      </div>
    </Container>
  );
};

export default PatrolListIframe;
